export default [
  {
    id: '1-2',
    parentId: '0',
    title: '代办',
    path: '/services/do-sth',
    type: 2,
    component: '/services/do-sth/do-sth',
    isHidden: true,
    icon: 'kl-project'
  }
]
